import React from 'react'
import './MoudleItem.css'

class MoudleItem extends React.Component {
    constructor(props) {
        super(props)
    }

    handleMoudleClick = () => {
        this.props.clickMoudleItem(this.props.itemIndex)
    };

    render(){
        return(
            <div onClick={this.handleMoudleClick} className='moudle_item_style'>
                <img style={{marginLeft:this.props.mleft}} className='moudle_image_style' src={this.props.imageUrl} />
            </div>
        );
    }
}

export default MoudleItem